<template>
  <v-container container-fluid-xs>
    <v-toolbar height="44px" class="sub-header">
      <v-toolbar-title class="body-2">Controller Time Sync</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <v-btn icon slot="activator" v-on:click="refresh">
          <v-avatar title="Refresh" class="avatar-bg">
            <v-icon>refresh</v-icon>
          </v-avatar>
        </v-btn>
        <span>Refresh</span>
      </v-tooltip>
    </v-toolbar>
    <data-table :headers="headers" :loading="loading" :data="data" errorMessage="-"></data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import IotApi from '@/services/Iot';

export default {
  components: {
    'data-table': () => import('@/components/utility/DataTable-mod.vue'),
  },
  data() {
    return {
      interval: null,
      loading: false,
      data: [],
      headers: [
        {
          text: 'Controller ID',
          value: 'rpi_id'
        },
        {
          text: 'Server Time',
          value: 'server_time'
        },
        {
          text: 'Controller Time',
          value: 'epic_time'
        }
      ]
    }
  },
  mounted() {  
    this.fetchData()
    this.interval = setInterval(this.fetchData, 60000)
  },
  methods: {
    async fetchData() {
      this.loading = true
      let response = await IotApi.getEpicGpsTime(this.getSelectedPlantId)
      this.loading = false
      this.data = response.data.result
    },
    refresh() {
      this.fetchData()
      if(this.interval) {
        clearInterval(this.interval)
        this.interval = setInterval(this.fetchData, 60000)
      }
    }
  },
  beforeDestroy() {
    if(this.interval) {
      clearInterval(this.interval)
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId']),
  },
}
</script>

<style>

</style>